import { css } from 'emotion';

import getFontStyles from '../../../../../lib/styles/getFontStyles';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

import {
  ISettingsColors,
  ISettingsFonts,
  ISettings,
  EpisodesLayout,
} from '@wix/podcasts-common/dist/settings';

interface IGetStylesArgs {
  colors: ISettingsColors['main'];
  fonts: ISettingsFonts['main'];
  deviceType: TPADeviceType;
  mainSettings: ISettings['main'];
}

function getStyles({
  colors,
  fonts,
  deviceType,
  mainSettings,
}: IGetStylesArgs) {
  const searchInputColor =
    mainSettings.episodesLayout === EpisodesLayout.LIST
      ? colors.episodeDescriptionColor
      : colors.textColor;

  return {
    searchIcon: css({
      color: searchInputColor,
    }),
    searchInput: css({
      '::placeholder': {
        color: searchInputColor,
      },
      color: searchInputColor,
      opacity: 0.6,
      ...getFontStyles(fonts.episodeDescriptionFont),
      '&:hover, &:focus, &:valid': {
        opacity: 1,
      },
      border: 'none',
      borderBottom: `1px solid transparent`,
      '&:focus, &:valid': {
        borderBottomColor: searchInputColor,
      },
    }),
    resetButton: css({
      color: searchInputColor,
    }),
    noResultsText: css({
      color: searchInputColor,
      ...getFontStyles(fonts.episodeDescriptionFont),
      ...{
        [TPADeviceType.DESKTOP]: {
          fontSize: 26,
        },
        [TPADeviceType.MOBILE]: {
          fontSize: 22,
        },
      }[deviceType],
    }),
    noResultsResetButton: css({
      color: colors.episodeButtonColor,
      ...getFontStyles(fonts.episodeDescriptionFont),
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'none',
      },
      ...{
        [TPADeviceType.DESKTOP]: {
          fontSize: 16,
        },
        [TPADeviceType.MOBILE]: {
          fontSize: 14,
        },
      }[deviceType],
    }),
  };
}

export default getStyles;
